// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconCircleArrowUp = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M32 56C46.809 56 56 46.809 56 32C56 17.191 46.809 8 32 8C17.191 8 8 17.191 8 32C8 46.809 17.191 56 32 56ZM18.0311 28.3038C18.7253 27.6571 30.3339 16.979 30.9775 16.3794C31.621 15.7797 32.3789 15.7797 33.0225 16.3794C33.6661 16.979 45.2747 27.6571 45.9689 28.3039C46.663 28.9506 46.6779 29.7911 46.007 30.462C45.3361 31.1329 44.9865 31.4826 44.3156 32.1534C43.6447 32.8243 42.8042 32.8095 42.1574 32.1154C41.7394 31.6666 37.1028 26.6284 33.8745 23.1199C34.1617 28.9575 34.9816 45.6638 34.9995 46.4482C35.0211 47.3993 34.4338 48 33.4825 48H30.5175C29.5662 48 28.9789 47.3993 29.0005 46.4482C29.0184 45.6638 29.8383 28.9573 30.1254 23.1198C26.8972 26.6283 22.2606 31.6665 21.8425 32.1152C21.1957 32.8094 20.3553 32.8242 19.6844 32.1533C19.0135 31.4825 18.6639 31.1329 17.993 30.462C17.3221 29.7911 17.337 28.9506 18.0311 28.3038Z" />
    </svg>
  );
};
